import React, { useState, useCallback, useEffect } from "react";
import { Tooltip } from "@mui/material";

export interface TruncatedTooltipProps {
    title: React.ReactNode;
    tooltipClasses?: { tooltip?: string };
    children: React.ReactElement;
}

export function TruncatedTooltip({ title, tooltipClasses, children }: TruncatedTooltipProps) {
    const [isTruncated, setIsTruncated] = useState(false);
    const [node, setNode] = useState<HTMLElement | null>(null);

    const refCallback = useCallback((el: HTMLElement | null) => {
        setNode(el);
    }, []);

    useEffect(() => {
        if (!node) {
            setIsTruncated(false);
            return;
        }

        const checkTruncation = () => {
            setIsTruncated(node.scrollWidth > node.clientWidth);
        };

        checkTruncation();

        const resizeObserver = new ResizeObserver(checkTruncation);
        resizeObserver.observe(node);

        return () => resizeObserver.disconnect();
    }, [node]);

    const childWithRef = React.isValidElement(children)
        ? React.cloneElement(children, { ref: refCallback } as React.HTMLAttributes<HTMLElement>)
        : children;

    return (
        <Tooltip
            title={title}
            placement="top"
            disableHoverListener={!isTruncated}
            classes={tooltipClasses}
        >
            {childWithRef}
        </Tooltip>
    );
}
